const iosPrices = {
  USD: '$14.99',
  GBP: '£13.49',
  AUD: '$20.99',
  EUR: '15,49 €',
  MXN: '$269.00',
  NOK: '149,00 kr',
  NZD: '$23.99',
  SEK: '155,00 kr',
  HUF: '4 990 Ft',
  CHF: 'CHF 16.00',
  MYR: 'RM62.90',
  PLN: '67,99 zł'
};

const androidPrices = {
  USD: '$14.99',
  GBP: '£12.99',
  AUD: '$20.99',
  EUR: '14.99 €',
  MXN: '$279.00',
  NOK: '145,00 kr',
  NZD: '$22.99',
  SEK: '149,00 kr',
  HUF: '4 790 Ft',
  CHF: 'CHF 14.00',
  MYR: 'RM57.99',
  PLN: '61,99 zł'
};

export default function getPrice(currencyCode) {
  const prices = window.Android ? androidPrices : iosPrices;
  return prices[currencyCode] ? prices[currencyCode] : prices.USD;
}
